import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../utils/breadCrumbs";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  ContainerBB,
  TitleBB,
  TitleJunction,
  ButtonRemove,
} from "./expedition.styled";
import { getDateFormatTimeZone } from "../../../../utils/formats";

const SecadoView = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, openExpedition, registerBB, finish, removeItem } = props;

  let sumIn = 0;
  let sumOut = 0;

  if (data) {
    if (data.in && data.in.length > 0) {
      for (const dataIn of data.in) {
        sumIn += dataIn.weight;
      }
    }
    if (data.out && data.out.length > 0) {
      for (const dataOut of data.out) {
        sumOut += dataOut.weight;
      }
    }
  }

  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.standAloneProcess.expeditionTitle") },
  ];

  const renderBB = (bbs, isInput = true) => {
    if (bbs && bbs.length > 0) {
      return bbs.map((bb) => {
        return (
          <div className="row mb-1" key={bb.batch}>
            <div className="col-4">{bb.batch}</div>
            <div className="col-4 text-center">{`${bb.itemCode} (${bb.variety})`}</div>
            <div className="col-2 text-end">{`${bb.weight}Kg`}</div>
            <div className="col-2 text-end">
              {isInput && (
                <ButtonRemove type="button" onClick={() => removeItem(bb)}>
                  <i className="fa-solid fa-trash-can"></i>
                </ButtonRemove>
              )}
            </div>
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-12 text-center">
            {t("forms.standAloneProcess.noBb")}
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <div className="row justify-content-center mt-4 mt-md-5">
        <div className="col-12 col-md-11">
          <h3 className="title">
            {t(`forms.standAloneProcess.expeditionTitle`)}
          </h3>
        </div>
      </div>
      <Breadcrumb items={breads} />

      {!data && (
        <div className="row justify-content-center mt-4">
          <div className="col-12 col-md-11 text-center">
            <div>{t("forms.standAloneProcess.noExpedition")}</div>
            <div>
              <button
                type="button"
                className="btn btn-lg btn-primary mt-5"
                onClick={() => openExpedition()}
              >
                {t("forms.standAloneProcess.buttons.expeditionInit")}
              </button>
            </div>
          </div>
        </div>
      )}
      {data && (
        <>
          <div className="row justify-content-center mt-4">
            <TitleJunction className="col-12 col-md-11 d-flex justify-content-between">
              <div>
                {`${t(
                  "forms.standAloneProcess.expeditionOpen"
                )} (${getDateFormatTimeZone(
                  data.dateInit,
                  "DD-MM-yyyy HH:mm"
                )})`}
              </div>
              <button
                type="button"
                className="btn btn-md btn-secondary"
                onClick={() => finish(sumIn, sumOut)}
              >
                {t("forms.standAloneProcess.buttons.expeditionFinish")}
              </button>
            </TitleJunction>
          </div>
          <div className="row justify-content-center mt-2">
            <div className="col-12 col-md-11">
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <TitleBB className="col-12 d-flex justify-content-between">
                      <div>{t("forms.junction.bbIn")}</div>
                      <div>{`Total: ${sumIn}Kg`}</div>
                    </TitleBB>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <ContainerBB>{renderBB(data.in)}</ContainerBB>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-center">
                  <button
                    type="button"
                    className="btn btn-lg btn-primary mt-5"
                    onClick={() => registerBB("IN")}
                  >
                    {t("forms.junction.buttons.in")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

SecadoView.propTypes = {
  // handleSubmit: PropTypes.func,
  // initialValues: PropTypes.object,
};

export default SecadoView;
